var __jsx = React.createElement;
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/compare/OfferInfo.module.scss';
import withFullPopup from '../../elements/withFullPopup';
import BCTerms from './BCTerms';

var BCTeaser = function BCTeaser() {
  var _useState = useState(false),
      isOpen = _useState[0],
      editIsOpen = _useState[1];

  var openTerms = function openTerms() {
    editIsOpen(true);
  };

  var closeTerms = function closeTerms() {
    editIsOpen(false);
  };

  var Terms = withFullPopup(BCTerms);
  return __jsx(Row, {
    className: "pt-3 ".concat(styles.bcTeaser)
  }, __jsx(Col, {
    className: "d-flex align-items-center"
  }, __jsx(FontAwesomeIcon, {
    icon: faAward,
    width: "16",
    height: "16",
    size: "2x",
    className: "mr-3 green"
  }), __jsx("div", null, "Aplic\u0103 la un credit pe Conso \u0219i \xEE\u021Bi po\u021Bi consulta gratuit situa\u021Bia de la Biroul de Credit. ", __jsx("span", {
    onClick: openTerms,
    className: styles.link
  }, "Condi\u021Bii"))), isOpen && __jsx(Terms, {
    title: "Condi\u021Bii de acces la situa\u021Bia de la Biroul de Credit",
    closePopup: closeTerms,
    close: closeTerms
  }));
};

export default BCTeaser;